import { React, PT, connect } from '@gasbuddy/react';
import { Container, Button, Input } from 'semantic-ui-react';

class SearchBox extends React.Component {
  state = {
    searchValue: '',
    loading: false,
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading) {
      this.setState({ loading: false });
    }
  }

  setSearchValue(e, data) {
    this.setState({ searchValue: data.value });
  }

  search() {
    const { searchValue } = this.state;
    const { searchCallback } = this.props;
    this.setState({ loading: true });
    searchCallback(searchValue);
  }

  render() {
    const { loading } = this.state;
    return (
      <Container>
        <Input
          control="Input"
          icon="search"
          placeholder="Enter POI ID"
          onChange={(e, data) => this.setSearchValue(e, data)}
        />
        <Button
          onClick={() => this.search()}
          primary
          loading={loading}
        >
Search
        </Button>
      </Container>
    );
  }
}

SearchBox.defaultProps = {
  loading: false,
};

SearchBox.propTypes = {
  loading: PT.bool,
  searchCallback: PT.func.isRequired,
};

export const PoiSearch = connect(state => state)(SearchBox);
